import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';

@Component({
  standalone: true,
  imports: [LoadingSpinnerComponent],
  selector: 'nrc-loading',
  templateUrl: './loading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent {}
